import React, { useState, useEffect, useContext } from "react"
import ImageFromDrupal from "gatsby-theme-blank/src/components/Image/image-from-drupal"
import {
  backgroundContainer,
  backgroundContainerBis,
  backgroundContainerDetails,
  backgroundWrapper,
  backgroundInputWrapper,
  background,
  backgroundText,
  notificationButton,
  searchButton,
  searchButtonListing,
  headerLightBoxOpener,
} from "./header-top.module.scss"
import SearchResults from "gatsby-theme-blank/src/components/search-results"
import Icon from "gatsby-theme-blank/src/components/Icon/icon"
import root from "window-or-global"
import PropTypes from "prop-types"
import {
  SearchButton,
  NotificationButton,
  BackgroundText,
  Container,
} from "./header-top-styled"
import { NotificationContext } from "gatsby-theme-blank/src/components/notification-context"
import { useBuildData } from "gatsby-theme-blank/src/hooks/use-build-data"
import EditButton from "gatsby-theme-blank/src/components/EditButton/edit-button"
import { LightBoxCarouselOpener } from "gatsby-theme-blank/src/components/LightBoxImage/light-box-image"

const HeaderTop = ({
  isIndex,
  isDetail,
  message,
  children,
  isGdd,
  inputHidden,
}) => {
  const buildInfos = useBuildData().site_settings
  const [results, setResults] = useState([])
  const [searchQuery, setSearchQuery] = useState("")
  const { setIsOpen } = useContext(NotificationContext)
  const [localNavigator, setLocalNavigator] = useState(null)

  useEffect(() => {
    if (searchQuery && root.__LUNR__) {
      root.__LUNR__.__loaded.then((lunr) => {
        const refs = lunr.fr.index.search(
          `${searchQuery}^100 ${searchQuery}*^10 ${searchQuery}~2`
        )
        const posts = refs.map(({ ref }) => lunr.fr.store[ref])
        setResults(posts)
      })
    }
  }, [searchQuery])

  useEffect(() => {
    setLocalNavigator(navigator)
  }, [])

  let containerClass
  if (isIndex) {
    containerClass = backgroundContainer
  } else if (isDetail) {
    containerClass = backgroundContainerDetails
  } else {
    containerClass = backgroundContainerBis
  }
  return (
    <>
      {!isGdd && (
        <Container className={containerClass}>
          <div className={backgroundWrapper}>
            {isIndex && <EditButton link={"/admin/site-configuration"} />}
            {isIndex && (
              <>
                <LightBoxCarouselOpener
                  images={[
                    {
                      type: "fromDrupal",
                      alt: "Bannière " + buildInfos.website_name,
                      id: buildInfos.header_banner.fid,
                    },
                  ]}
                  className={headerLightBoxOpener}
                />
                <ImageFromDrupal
                  className={background}
                  alt={"Bannière " + buildInfos.website_name}
                  drupal_fid={buildInfos.header_banner.fid}
                  ariaHidden={true}
                />
              </>
            )}
            {message && (
              <BackgroundText className={backgroundText}>
                <p>
                  {isIndex && <EditButton link={"/admin/site-configuration"} />}

                  {message}
                </p>
              </BackgroundText>
            )}
            {inputHidden ? null : (
              <div className={backgroundInputWrapper}>
                {buildInfos.webpush_enabled && localNavigator?.serviceWorker ? (
                  <NotificationButton
                    aria-label="Gestion des notifications"
                    className={notificationButton}
                    onClick={() => setIsOpen(true)}
                  >
                    <Icon icon="bell" size={16}></Icon>
                  </NotificationButton>
                ) : null}
                <input
                  type="search"
                  id="search-input"
                  name="keywords"
                  onChange={(element) => setSearchQuery(element.target.value)}
                  value={searchQuery}
                  placeholder="Rechercher..."
                  aria-label="Recherche"
                  aria-autocomplete="list"
                  aria-controls="list-result"
                  aria-expanded={inputHidden}
                  title="Recherche"
                  role="search"
                />
                <SearchButton
                  aria-label="Recherche"
                  className={isIndex ? searchButton : searchButtonListing}
                >
                  <Icon icon="search" size={16}></Icon>
                </SearchButton>
              </div>
            )}
          </div>
        </Container>
      )}
      {searchQuery !== "" && (
        <SearchResults query={searchQuery} resultats={results} />
      )}
      {searchQuery === "" && (
        <div>
          <main id={"main"}>{children}</main>
        </div>
      )}
    </>
  )
}

//-----------------------Prop-Types---------------------------//

HeaderTop.propTypes = {
  children: PropTypes.node.isRequired,
  isIndex: PropTypes.bool,
  isDetail: PropTypes.bool,
  message: PropTypes.string,
  isGdd: PropTypes.bool,
  inputHidden: PropTypes.bool,
}

//-----------------------Prop-Types---------------------------//

export default HeaderTop
